<script setup lang="ts">
withDefaults(
  defineProps<{
    title?: string
  }>(),
  {
    title: 'Kelola Ongkir & Cek Resi Shopify dalam Satu Klik'
  }
)
</script>
<template>
  <UiSectionWrapper
    :title="title"
    sub-title="Plugin Ongkir & Cek Resi Shopify"
    description="Optimalkan checkout, hemat waktu, dan tingkatkan kepuasan pelanggan dengan integrasi KiriminAja."
    hero-image="/images/plugin-shopify-banner-4.webp"
    class="bg-primary-container dark:bg-surface-container-high py-10 lg:py-0"
    image-class="hidden lg:block"
  >
    <template #action>
      <div class="flex items-center gap-2 lg:gap-4 py-2">
        <UiButton
          to="https://apps.shopify.com/kiriminaja"
          label="Install Plugin"
          target="_blank"
          icon="material-symbols:download"
        />
        <UiButton
          :to="$utm.utmUrlWithCustomMetaData('/kontak-kami')"
          label="Hubungi Kami"
          variant="primaryOutline"
          icon="material-symbols:call-outline"
        />
      </div>
    </template>
  </UiSectionWrapper>
</template>
